import { useEffect } from 'react';

import useBookmarkedRecipes from 'domain/recipe/useBookmarkedRecipes';
import LoadStatus from 'config/load_status';

const useBookmarksPage = () => {
  const {
    loadBookmarkedRecipes,
    bookmarkedRecipes,
    bookmarksFirstLoadStatus,
  } = useBookmarkedRecipes();

  useEffect(() => {
    loadBookmarkedRecipes();
  }, [loadBookmarkedRecipes]);

  const hasFinished = bookmarksFirstLoadStatus === LoadStatus.DONE;

  return {
    bookmarkedRecipes,
    loadBookmarkedRecipes,
    isLoading: bookmarksFirstLoadStatus === LoadStatus.LOADING,
    hasFinished,
    hasAnyRecipe: hasFinished && bookmarkedRecipes.length > 0,
  };
};

export default useBookmarksPage;
